import { useWidget } from 'context/widget.context'
import { Text } from 'preact-i18n'
import Assets from 'settings/asset.settings'
import style from './copyright.style.scss'

const Copyright = () => {
  const { formData } = useWidget()
  if (!formData || !formData.hasWatermark) return null
  return (
    <div className={style.copyright}>
     <Text id="copyright.text" />
     <a href={Assets.formBuilderUrl} target="_blank"><Text id="formaloo" /></a>
    </div>
  )
}
export default Copyright